import * as configcat from "@configcat/sdk";
import { FeatureFlagProvider, UserContext } from "./FeatureFlagProvider";

export default class ConfigCatProvider extends FeatureFlagProvider {
  constructor(sdkKey, environment) {
    super(sdkKey, environment);
  }

  initialize(user = new UserContext()) {
    this.user = user;
    const logger = configcat.createConsoleLogger(configcat.LogLevel.Info);

    if (this.configCatClient) {
      this.configCatClient.dispose();
    }

    this.configCatClient = configcat.getClient(
      sdkKey,
      configcat.PollingMode.AutoPoll,
      {
        logger: logger,
        pollIntervalSeconds: 30, // refresh local cache after x seconds
      }
    );
  }

  async getFeatureFlagValue(key, defaultValue) {
    const value = await this.configCatClient.getValueAsync(key, defaultValue, {
      userId: this.user.userID,
      email: this.user.email,
    });
    return value;
  }
}
